/**
 * Central list of feature flag keys available in the application.
 * Keep this list synchronized with all environment feature objects.
 */
export const app_feature_flags = {
  sidebar_input_or_upload_operators_hotfix:
    'sidebar_input_or_upload_operators_hotfix',
  data_refference_attributes: 'data_refference_attributes',
  data_reference: 'data_reference',
  help_center: 'help_center',
  website_analytics: 'website_analytics',
  sentry_telemetry: 'sentry_telemetry',
  connections: 'connections',
} as const;

/** Union type for feature flag names used by the application. */
export type AppFeatureFlag =
  (typeof app_feature_flags)[keyof typeof app_feature_flags];

/** Typed map of all application feature flags and their enabled state. */
export type FeatureFlags = Record<AppFeatureFlag, boolean>;
